import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiEstimativaService } from 'src/app/modules/shared/services/api-estimativa.service';
import { LanguageService } from 'src/app/modules/shared/services/language.service';
import { ResultDataService } from 'src/app/modules/shared/services/resultcombined-data.service';
import { ScrollControlService } from 'src/app/modules/shared/services/scroll-control.service';
import { SidenavService } from 'src/app/modules/shared/services/sidenav.service';
import { ProfileService } from 'src/app/modules/shared/services/profile.service';
import { Profile } from 'src/app/models/Profile';

@Component({
  standalone: false,
  selector: 'app-combined-result-estimate',
  templateUrl: './combined-result-estimate.component.html',
  styleUrls: ['./combined-result-estimate.component.css']
})
export class CombinedResultEstimateComponent implements OnInit {

  shouldPinSidenav: boolean = false;
  isOpen: boolean = false;

  combinedData: any;

  associationEstimates: any;


  variables: any;
  math = Math;
  message = '';

  div1Visible: boolean = false;
  div2Visible: boolean = false;
  div3Visible: boolean = false;
  div4Visible: boolean = false;
  div5Visible: boolean = false;
  div6Visible: boolean = false;
  div8Visible: boolean = false

  totalProjectRisk = 0;
  totalProjectRiskProfile = 0;
  totalProjectRiskCost = 0; 
  
  totalCostRisk: any;
  totalCostConfig: any;
  totalCostParams: any;
  totalCostMacros: any;
  totalCostActivities: any;
  totalCostProdTools: any;
  totalCostTotalRisk: number = 0;
 

  totalScrActivities: any = 0;
  totalScrConfig: any = 0;
  totalScrParams: any = 0;
  totalScrMacros: any = 0;
  totalScrRisk: any = 0;
  totalScrProdTools: any = 0;

  hasCosts: boolean = false;

  medios: any[] = [];
  closestItem: any;
  medium: any = 0;
  gestao: any = 0;
  conf: any = 0;
  desenv: any = 0;
  totalEst: any = 0;

  editMode: boolean = false;

  totalSumStr!: string;
  totalProjectRiskStr: any;
  totalConfigurationsStr!: string;
  totalParametersStr!: string;
  totalMacroStr!: string;
  totalCatalogStr!: string;
  totalToolsStr!: string;

  toggleDivVisibility(id: number): void {
    switch (id) {
      case 1:
        this.div1Visible = !this.div1Visible;
        break;
      case 2:
        this.div2Visible = !this.div2Visible;
        break;
      case 3:
        this.div3Visible = !this.div3Visible;
        break;
      case 4:
        this.div4Visible = !this.div4Visible;
        break;
      case 5:
        this.div5Visible = !this.div5Visible;
        break;
      case 6:
        this.div6Visible = !this.div6Visible;
        break;
      case 8:
        this.div8Visible = !this.div8Visible;
        break;
      default:
        break;
    }
  }

  checkButton(elemName: string) {
    if (!(elemName == this.variables.total || elemName == this.variables.totalNoRisk)) {
      return true;
    }
    else { return false; }
  }

  private getExpandableRowIdsInData(): number[] {
    const expandableIds = [2, 3, 4, 5, 6, 8];
    const currentRows = this.totalDataSource?.data as any[] || [];
    return expandableIds.filter((id) => currentRows.some((row) => row?.id === id));
  }

  hasExpandableRows(): boolean {
    return this.getExpandableRowIdsInData().length > 0;
  }

  areAllDetailTablesExpanded(): boolean {
    const expandableIds = this.getExpandableRowIdsInData();
    if (expandableIds.length === 0) {
      return false;
    }

    return expandableIds.every((id) => this.isParentRowExpanded({ id }));
  }

  toggleAllDetailTables(): void {
    const shouldExpandAll = !this.areAllDetailTablesExpanded();
    const expandableIds = this.getExpandableRowIdsInData();

    this.div2Visible = shouldExpandAll && expandableIds.includes(2);
    this.div3Visible = shouldExpandAll && expandableIds.includes(3);
    this.div4Visible = shouldExpandAll && expandableIds.includes(4);
    this.div5Visible = shouldExpandAll && expandableIds.includes(5);
    this.div6Visible = shouldExpandAll && expandableIds.includes(6);
    this.div8Visible = shouldExpandAll && expandableIds.includes(8);
  }

  getCostForProfile(profileId: string | null, hours: number): number {
    if (!profileId || !this.hasCosts || !Array.isArray(this.combinedData.resultEstimates?.profileSnapshots)) return 0;
    const snapshot = this.combinedData.resultEstimates.profileSnapshots.find((ps: any) => ps.profileId === profileId);
    return snapshot?.costPerHour ? hours * snapshot.costPerHour : 0;
  }

  getCostPerHourForProfile(profileId: string | null): number {
    if (!profileId || !this.hasCosts || !Array.isArray(this.combinedData.resultEstimates?.profileSnapshots)) return 0;
    const snapshot = this.combinedData.resultEstimates.profileSnapshots.find((ps: any) => ps.profileId === profileId);
    return snapshot?.costPerHour || 0;
  }

  getProfileName(profileId: string | null): string {
    if (!profileId || !Array.isArray(this.combinedData.resultEstimates?.profileSnapshots)) return '-';
    const snapshot = this.combinedData.resultEstimates.profileSnapshots.find((ps: any) => ps.profileId === profileId);
    return snapshot?.profileName || '-';
  }

  getProfileIdForItem(groupName: string, index: number): string | null {
    const group = this.combinedData.resultEstimates?.[groupName];
    if (!Array.isArray(group) || index >= group.length) return null;
    return group[index]?.profileId || null;
  }

  projectRiskDataSource: any = new MatTableDataSource();
  riskDisplayedColumns: string[] = ['name', 'dummy', 'riskEffort', 'complexity', 'risk', 'effort', 'profile', 'cost'];
  riskDisplayedColumnsNoCosts: string[] = ['name', 'dummy', 'dummy', 'dummy', 'riskEffort', 'complexity', 'risk', 'effort' ];

  configurationDataSource: any = new MatTableDataSource();
  configurationDisplayedColumns: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'complexity', 'profile', 'cost'];
  configurationDisplayedColumnsNoCosts: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy','complexity'];

  parametersDataSource: any = new MatTableDataSource();
  parametersDisplayedColumns: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'complexity', 'profile', 'cost'];
  parametersDisplayedColumnsNoCosts: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy', 'complexity'];

  macroDataSource: any = new MatTableDataSource();
  macroDisplayedColumns: string[] = ['name', 'metodology', 'dummy', 'dummy', 'complexity', 'effort', 'profile', 'cost'];
  macroDisplayedColumnsNoCosts: string[] = ['name', 'metodology', 'dummy', 'dummy', 'dummy', 'dummy', 'complexity', 'effort'];

  tasksDataSource: any = new MatTableDataSource();
  catalogDisplayedColumns: string[] = ['task', 'dummy', 'dummy', 'subTask', 'complexity', 'complexityCount', 'profile', 'cost'];
  catalogDisplayedColumnsNoCosts: string[] = ['task', 'dummy', 'dummy', 'subTask','dummy', 'dummy','complexity', 'complexityCount'];

  filteredCatalogDataSourceMode1: any[] = [];
  filteredCatalogDataSourceMode2: any[] = [];
  filteredCatalogDisplayedColumns: string[] = ['epic', 'userStory', 'task', 'subTask', 'complexity', 'complexityCount', 'profile', 'cost'];
  filteredCatalogDisplayedColumnsNoCosts: string[] = ['epic', 'dummy', 'dummy', 'userStory', 'task', 'subTask', 'complexity', 'complexityCount'];
  
  toolsDataSource:  any = new MatTableDataSource();
  toolsdisplayColumns: string[] = ['toolName', 'dummy', 'task', 'subTask', 'productivity', 'gains', 'profile', 'cost'];
  toolsdisplayColumnsNoCost: string[] = ['toolName', 'dummy', 'task', 'subTask', 'dummy', 'dummy','productivity', 'gains'];

  totalDataSource = new MatTableDataSource();
  totalDataSourceServices: any = [];
  totalDisplayedColumns: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy', 'effort'];
  totalDisplayedColumnsWithCost: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'effort', 'profile', 'cost'];
  expandedDetailColumns: string[] = ['expandedDetail'];

  cecoGcms: any = [];

  criticality = 0;
  totalConfigurations = 0;
  totalParameters = 0;
  totalMacro = 0;
  totalSubTasks = 0;
  totalSum = 0;
  totalCostTotal = 0;
  totalTools = 0;

  totalSumNoRisk = 0;
  totalCostTotalNoRisk = 0;
  totalSumTotalRisk = 0;
  averageProfile = 0;
  averageProfileMacro = 0;
  averageProfileSubTasks = 0;
  averageProfileConfig = 0;
  averageProfileParams = 0;
  averageProfileNoRisk = 0;
  averageProfileRisk = 0;
  averageProfileTools = 0;

  estimateResult: any[] = [];

  constructor(
    private languageService: LanguageService,
    private resultDataService: ResultDataService,
    private estimativaService: ApiEstimativaService,
    private sidenavService: SidenavService,
    private router: Router,
    private profileService: ProfileService,
    private scrollService: ScrollControlService) {
    // Retrieve data from the shared service
    this.combinedData = this.resultDataService.getParentData();
    this.associationEstimates = this.resultDataService.getAssociatedEstimatesData();
  }

  ngOnInit(): void {

    if (!this.combinedData.resultEstimates) {
      this.router.navigate(['/projectos']);
    }

    this.scrollService.setScroll(true);

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    
      this.profileService.getAllProfiles().subscribe({
        next: (profiles: any[]) => {
          // Build temporary profileSnapshots from live profile data
          const allProfileIds = new Set<string>();


          this.combinedData.resultEstimates?.configurations.rows.forEach((c: any) => { if (c.profileId) allProfileIds.add(c.profileId); });
          this.combinedData.resultEstimates?.parameters.rows.forEach((p: any) => { if (p.profileId) allProfileIds.add(p.profileId); });
          this.combinedData.resultEstimates?.macroActivities?.rows.forEach((m: any) => {
              if (m.profileId) allProfileIds.add(m.profileId);
            });
          this.combinedData.resultEstimates?.projectActivities?.rows.forEach((st: any) => { if (st.profileId) allProfileIds.add(st.profileId); });

          //create a unique list of profileIds
          this.combinedData.resultEstimates.profileSnapshots = Array.from(allProfileIds).map(id => {
            const profile = profiles.find(p => p.id === id);
            return profile ? { profileId: profile.id, profileName: profile.name, profileCenter: profile.center, costPerHour: profile.costPerHour || 0 } : null;
          }).filter((s: any) => s !== null);

          this.checkHasCosts();

          this.setAllTotal(this.combinedData.resultEstimates);
          this.setTable(this.combinedData.resultEstimates, 'all');
        },
        error: () => {
          // If profiles can't be loaded, calculate without costs
          this.checkHasCosts();
          this.setAllTotal(this.combinedData.resultEstimates);
          this.setTable(this.combinedData.resultEstimates, 'all');
        }
      });
    
  }

  checkHasCosts(): void {
    /*this.hasCosts = Array.isArray(this.combinedData.resultEstimates?.profileSnapshots) &&
      this.combinedData.resultEstimates.profileSnapshots.some((ps: any) => ps.costPerHour && ps.costPerHour > 0);
    */
     this.hasCosts = this.combinedData.resultEstimates?.result.hasCosts;
  }

  setAllTotal(summaryDTO: any) {

    this.totalConfigurations = summaryDTO.configurations.totalEffort;
    this.totalCostConfig = summaryDTO.configurations.totalCost;
    this.averageProfileConfig =  this.totalCostConfig / this.totalConfigurations;

    this.totalParameters = summaryDTO.parameters.totalEffort;
    this.totalCostParams = summaryDTO.parameters.totalCost;
    this.averageProfileParams =  this.totalCostParams / this.totalParameters;

    this.totalMacro = summaryDTO.macroActivities.totalEffort;
    this.totalCostMacros = summaryDTO.macroActivities.totalCost;
    this.averageProfileMacro =  this.totalCostMacros / this.totalMacro;

    this.totalSubTasks = summaryDTO.projectActivities.totalEffort;
    this.totalCostActivities = summaryDTO.projectActivities.totalCost;
    this.averageProfileSubTasks =  this.totalCostActivities / this.totalSubTasks;

    this.totalTools = summaryDTO.productivityEarnings.totalEffort;
    this.totalCostProdTools = summaryDTO.productivityEarnings.totalCost;
    this.averageProfileTools =  this.totalCostProdTools / this.totalTools;

    this.totalProjectRisk = summaryDTO.risk.totalEffort;
    this.totalCostRisk = summaryDTO.risk.totalCost;
    this.averageProfileRisk =  this.totalCostRisk / this.totalProjectRisk;

    //final total without risk 
    this.totalSumNoRisk = this.totalConfigurations + this.totalParameters + this.totalMacro + this.totalSubTasks - this.totalTools;
    this.totalCostTotalNoRisk = this.totalCostConfig + this.totalCostParams + this.totalCostMacros + this.totalCostActivities - this.totalCostProdTools;
    //check with summarDTO values to set the totalSumNoRisk and totalCostTotalNoRisk
    console.log("summaryDTO.result.totalNoRisk:"+summaryDTO.result.totalNoRisk);
    console.log("summaryDTO.result.totalCostNoRisk:"+summaryDTO.result.totalCostNoRisk);
    console.log("Local sums: "+this.totalSumNoRisk);
    console.log("Local costs: "+this.totalCostTotalNoRisk);
    
    //using summary data
    this.totalSumNoRisk = summaryDTO.result.totalNoRisk;
    this.totalCostTotalNoRisk = summaryDTO.result.totalCostNoRisk

    //final total with risk
    this.totalSum = this.totalProjectRisk + this.totalConfigurations + this.totalParameters + this.totalMacro + this.totalSubTasks - this.totalTools;
    this.totalCostTotal = this.totalCostRisk + this.totalCostConfig + this.totalCostParams + this.totalCostMacros + this.totalCostActivities - this.totalCostProdTools;
  
    //check with summarDTO values to set the totalSum and totalCostTotal
    console.log("summaryDTO.result.finalTotal:"+summaryDTO.result.finalTotal);
    console.log("summaryDTO.result.finalTotalCost:"+summaryDTO.result.finalTotalCost);
    console.log("Local sums: "+this.totalSum);
    console.log("Local costs: "+this.totalCostTotal);

    //using summary data
    this.totalSum = summaryDTO.result.finalTotal;
    this.totalCostTotal = summaryDTO.result.finalTotalCost; 
  
  }

  setTable(summaryDTO: any, typeTable: string) {

    switch (typeTable) {
      case 'all':
        this.configTable(summaryDTO);
        this.paramsTable(summaryDTO);
        this.macrosTable(summaryDTO);
        this.tasksTable(summaryDTO);
        this.prodTable(summaryDTO);
        this.riskTable(summaryDTO);
        break;
      default:
        break;
    }

    let itemCount = 0;
    if (summaryDTO.configurations && summaryDTO.configurations.rows.length > 0)
      itemCount++;
    if (summaryDTO.parameters && summaryDTO.parameters.rows.length > 0)
      itemCount++;
    if (summaryDTO.macroActivities && summaryDTO.macroActivities.rows.length > 0)
      itemCount++;
    if (summaryDTO.projectActivities && summaryDTO.projectActivities.rows.length > 0)
      itemCount++;

    this.averageProfile = (this.averageProfileMacro + this.averageProfileSubTasks + this.averageProfileConfig + this.averageProfileParams)/itemCount;
    this.averageProfileNoRisk =  (this.totalCostTotalNoRisk/this.totalSumNoRisk);

    // Build data source dynamically based on what values are present
    const dataSourceItems: any[] = [];

    if (this.totalConfigurations > 0) {
      if (this.hasCosts)
        dataSourceItems.push({ name: this.variables.configurations, effort: Number(this.totalConfigurations).toFixed(2), profile: Number(this.averageProfileConfig).toFixed(2), cost: Number(this.totalCostConfig).toFixed(2), id: 2 });
      else
        dataSourceItems.push({ name: this.variables.configurations, effort: Number(this.totalConfigurations).toFixed(2), id: 2 });
    }

    if (this.totalParameters > 0) {
      if (this.hasCosts)
        dataSourceItems.push({ name: this.variables.parameters, effort: Number(this.totalParameters).toFixed(2), profile: Number(this.averageProfileParams).toFixed(2), cost: Number(this.totalCostParams).toFixed(2), id: 3 });
      else
        dataSourceItems.push({ name: this.variables.parameters, effort: Number(this.totalParameters).toFixed(2), id: 3 });
    }

    if (this.hasCosts)
      dataSourceItems.push({ name: this.variables.macroActivities, effort: Number(this.totalMacro).toFixed(2), profile: Number(this.averageProfileMacro).toFixed(2), cost: Number(this.totalCostMacros).toFixed(2), id: 4 });
    else
      dataSourceItems.push({ name: this.variables.macroActivities, effort: Number(this.totalMacro).toFixed(2),  id: 4 });      
    
    if (this.hasCosts)
      dataSourceItems.push({ name: this.variables.projectTasks, effort: Number(this.totalSubTasks).toFixed(2), profile: Number(this.averageProfileSubTasks).toFixed(2), cost: Number(this.totalCostActivities).toFixed(2), id: 5 });
    else
      dataSourceItems.push({ name: this.variables.projectTasks, effort: Number(this.totalSubTasks).toFixed(2), id: 5 });

    if (this.totalTools > 0) {
      if (this.hasCosts)
        dataSourceItems.push({ name: this.variables.prodTools, effort: Number(this.totalTools).toFixed(2), profile: Number(this.averageProfileTools).toFixed(2), cost: Number(this.totalCostProdTools).toFixed(2), id: 6 });
      else
        dataSourceItems.push({ name: this.variables.prodTools, effort: Number(this.totalTools).toFixed(2), id: 6 }); 
    }

    if (this.hasCosts)
      dataSourceItems.push({ name: this.variables.totalNoRisk,  effort: Number(this.totalSumNoRisk).toFixed(2), profile: Number(this.averageProfileNoRisk).toFixed(2), cost: Number(this.totalCostTotalNoRisk).toFixed(2), id: 7 });
    else
      dataSourceItems.push({ name: this.variables.totalNoRisk, effort: Number(this.totalSumNoRisk).toFixed(2), id: 7 });

    //lowest value in sorted table
    const profileCost = this.getCostPerHourForProfile(summaryDTO?.risk.rows?.[0]?.profileId || null);

    if (this.hasCosts)
      dataSourceItems.push({ name: this.variables.riskOfProject, effort: Number(this.totalProjectRisk).toFixed(2), profile: Number(profileCost).toFixed(2), cost: Number(this.totalCostRisk).toFixed(2), id: 8 }); 
    else
      dataSourceItems.push({ name: this.variables.riskOfProject, effort: Number(this.totalProjectRisk).toFixed(2), id: 8 });

    const finalCostEuros = this.totalCostTotal;
    const finalEffortHours = this.totalSum;
    if (this.hasCosts)
      dataSourceItems.push({ name: this.variables.total, effort: Number(finalEffortHours).toFixed(2), 
                            profile: finalEffortHours > 0 ? Number((finalCostEuros / finalEffortHours).toFixed(2)) : 0, 
                            cost: Number(finalCostEuros).toFixed(2), id: 9 });
    else
      dataSourceItems.push({ name: this.variables.total, effort: Number(finalEffortHours).toFixed(2), id: 9 });

    this.totalDataSource.data = dataSourceItems;

  }

riskTable(summaryDTO: any) {

    summaryDTO.risk.rows.forEach((row: any) => {

      this.projectRiskDataSource.data.push({
        name: row.name,
        risk: row.risk,
        effort: (row.risk/100.) * this.totalSumNoRisk, //without risk of course
        profile: this.getCostPerHourForProfile(row.profileId),
        profileName: this.getProfileName(row.profileId),
        profileId: row.profileId,
        cost: row.cost
      });
    });

  }
  
  prodTable(summaryDTO: any) {

    summaryDTO.productivityEarnings.rows.forEach((row: any) => {

      this.toolsDataSource.data.push({
        actionName: row.task,
        activityName: row.subTask,
        toolName: row.toolName,
        gains: row.gains,
        productivity:row.productivity,
        profileName: this.getProfileName(row.profileId),
        profile: this.getCostPerHourForProfile(row.profileId),
        profileId: row.profileId,
        cost: row.costSavings
      })
    });
  }

  tasksTable(summaryDTO: any) {

    // Set data for mat table (Activities table)
    summaryDTO.projectActivities.rows.forEach((row: any, i: number) => {
  
      this.tasksDataSource.data.push({
        epic: row.epic,
        userStory: row.userStory,
        task: row.task,
        subTask: row.subTask,
        complexityLevel: row.complexityLevel,
        tshirtScaleLevel: row.tshirtScaleLevel,
        complexityCount: row.itemCount + ' x ' + (row.complexity / row.itemCount).toFixed(2) + ' = ' + row.complexity.toFixed(2),
        profileName: this.getProfileName(row.profileId),
        profile: this.getCostPerHourForProfile(row.profileId),
        cost: row.cost,
        profileId : row.profileId,
        sourceGroup: 'subTasks',
        sourceIndex: i,
      });
    })

    this.filterDataSource();
  }

  macrosTable(summaryDTO: any) {

    summaryDTO.macroActivities.rows.forEach((row: any, i: number) => {

      this.macroDataSource.data.push({
          name: row.name,
          type: row.type,
          effort: row.effort,
          complexity: row.complexity,
          profileName: this.getProfileName(row.profileId),
          profile: this.getCostPerHourForProfile(row.profileId),
          cost: row.cost,
          profileId: row.profileId,
          sourceGroup: 'macroActivities',
          sourceMacroIndex: i,
          sourceName: row.name,
        })
    });
  }

  paramsTable(summaryDTO: any) {

    summaryDTO.parameters.rows.forEach((row: any, i: number) => {
      this.parametersDataSource.data.push({
        name: row.name,
        complexity: row.complexity,
        profileName: this.getProfileName(row.profileId),
        profile: this.getCostPerHourForProfile(row.profileId),
        cost: row.cost,
        profileId: row.profileId,
        sourceGroup: 'parameters',
        sourceIndex: i,
      })
    })
  }

  configTable(summaryDTO: any) {
   
    summaryDTO.configurations.rows.forEach((row: any, i: number) => {

      this.configurationDataSource.data.push({
        name: row.name,
        complexity: row.complexity,
        profileName: this.getProfileName(row.profileId),
        profile: this.getCostPerHourForProfile(row.profileId),
        cost: row.cost,
        profileId: row.profileId,
        sourceGroup: 'configurations',
        sourceIndex: i,
      })
    })
  }

  filterDataSource() {
    const dataArray = this.tasksDataSource.data;
    this.filteredCatalogDataSourceMode1 = dataArray.filter((item: any) => item.complexityLevel !== null);
    this.filteredCatalogDataSourceMode2 = dataArray.filter((item: any) => item.tshirtScaleLevel !== null);
  }


  calcMediumGCMClosest(goal: number) {
    const closest = this.medios.reduce(function (prev, curr) {
      return (Math.abs(curr.media - goal) < Math.abs(prev.media - goal) ? curr : prev);
    });
    this.closestItem = closest;
  }

  exportExcel() {
    const associationEstimatesAndMetaData = {
      estimateMode: this.combinedData.estimateMode,
      name: this.combinedData.name,
      project: this.combinedData.project,
      projectMetodology: this.combinedData.projectMetodology,
      estimates: this.associationEstimates
    }

    //get ids from associationEstimates
    const estimateIds: string[] = this.associationEstimates.map((estimate: any) => estimate.id);
    this.estimativaService.exportAssociationExcel(estimateIds).subscribe(data => {
      if (data) {
        this.downloadExcel(data, "Association " + this.combinedData.name + ' Result.xlsx')
      }
    })
  }

  downloadExcel(response: any, fileName: any) {
    // Doing it this way allows you to name the file
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(response);
    link.download = fileName;
    link.click();
  }

  getGcm(estimate: any) {
    this.cecoGcms = estimate.catalog.cecoGcms;

    return this.cecoGcms.map(function (str: any) {
      return parseFloat(str);
    });
  }

  onSidenavToggle() {
    this.isOpen = !this.isOpen;
    this.sidenavService.sideNavState$.next(this.isOpen);
  }

  onCheckboxChange(event: any) {
    this.shouldPinSidenav = event;
    this.sidenavService.shouldPinSidenavState.next(this.shouldPinSidenav);
  }

  isLastRow(totalDataSource: any, index: number): boolean {
    return index === totalDataSource.filteredData.length - 1;
  }

    isNoRiskSubTotalRow(totalDataSource: any, index: number): boolean {
    return index === totalDataSource.filteredData.length - 3;
  }
  isParentRowExpanded(row: any): boolean {
    if (row?.id === 8) {
      return this.div8Visible;
    }
    if (row?.id === 2) {
      return this.div2Visible;
    }
    if (row?.id === 3) {
      return this.div3Visible;
    }
    if (row?.id === 4) {
      return this.div4Visible;
    }
    if (row?.id === 5) {
      return this.div5Visible;
    }
    if (row?.id === 6) {
      return this.div6Visible;
    }
    return false;
  }

  isExpandedDetailRow = (_index: number, row: any): boolean => {
    return this.checkButton(row?.name) && this.isParentRowExpanded(row);
  };

  getExpandedColumns(row: any): string[] {
    switch (row?.id) {
      case 2:
        return this.hasCosts ? this.configurationDisplayedColumns : this.configurationDisplayedColumnsNoCosts;
      case 3:
        return this.hasCosts ? this.parametersDisplayedColumns : this.parametersDisplayedColumnsNoCosts;
      case 4:
        return this.hasCosts ? this.macroDisplayedColumns : this.macroDisplayedColumnsNoCosts;
      case 5:
        if (this.combinedData?.projectMetodology === 'agile' && this.combinedData?.estimateMode === 'complex') {
          return this.hasCosts ? this.filteredCatalogDisplayedColumns : this.filteredCatalogDisplayedColumnsNoCosts;
        }
        if (this.combinedData?.projectMetodology === 'agile' && this.combinedData.estimateMode === 'tshirt') {
          return this.hasCosts ? this.filteredCatalogDisplayedColumns : this.filteredCatalogDisplayedColumnsNoCosts;
        }
        return this.hasCosts ? this.catalogDisplayedColumns : this.catalogDisplayedColumnsNoCosts;
      case 6:
        return this.hasCosts ? this.toolsdisplayColumns : this.toolsdisplayColumnsNoCost;
      case 8:
        return this.hasCosts ? this.riskDisplayedColumns : this.riskDisplayedColumnsNoCosts;
      default:
        return [];
    }
  }

  getExpandedRows(row: any): any[] {
    switch (row?.id) {
      case 2:
        return this.configurationDataSource.data;
      case 3:
        return this.parametersDataSource.data;
      case 4:
        return this.macroDataSource.data;
      case 5:
        if (!this.combinedData.complexityLevel && !this.combinedData.tshirtScaleLevel)
          return this.tasksDataSource.data;

        if (this.combinedData?.projectMetodology === 'agile' && this.combinedData?.estimateMode === 'complex')
          return this.filteredCatalogDataSourceMode1;
        else if (this.combinedData?.projectMetodology === 'agile' && this.combinedData?.estimateMode === 'tshirt')
          return this.filteredCatalogDataSourceMode2;

        return this.tasksDataSource.data;

        case 6:
        return this.toolsDataSource.data;
      case 8:
        return this.projectRiskDataSource.data;
      default:
        return [];
    }
  }

  getExpandedHeader(row: any, column: string): string {
    if (column === 'dummy') {
      return '';
    }

    switch (row?.id) {
      case 2:
      case 3:
        return this.getConfigParamHeader(column);
      case 4:
        return this.getMacroHeader(column);
      case 5:
        return this.getTaskHeader(column);
      case 6:
        return this.getToolHeader(column);
      case 8:
        return this.getRiskHeader(column);
      default:
        return '';
    }
  }

  getExpandedCellValue(row: any, column: string, detail: any): string {
    if (column === 'dummy') {
      return '';
    }

    switch (row?.id) {
      case 2:
      case 3:
        return this.getConfigParamCellValue(column, detail);
      case 4:
        return this.getMacroCellValue(column, detail);
      case 5:
        return this.getTaskCellValue(column, detail);
      case 6:
        return this.getToolCellValue(column, detail);
      case 8:
        return this.getRiskCellValue(column, detail);
      default:
        return '';
    }
  }

  private getConfigParamHeader(column: string): string {
    switch (column) {
      case 'name':
        return this.variables.description;
      case 'complexity':
        return `${this.variables.effort} (${this.variables.hours})`;
      case 'profile':
        return `${this.variables.profile} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.variables.cost;
      default:
        return '';
    }
  }

  private getMacroHeader(column: string): string {
    switch (column) {
      case 'name':
        return this.variables.description;
      case 'metodology':
        return this.variables.metodology;
      case 'complexity':
        return `${this.variables.effort} (%)`;
      case 'effort':
        return `${this.variables.effort} (${this.variables.hours})`;
      case 'profile':
        return `${this.variables.profile} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.variables.cost;
      default:
        return '';
    }
  }

  private getTaskHeader(column: string): string {
    if (this.combinedData.projectMetodology === 'agile' && this.combinedData.estimateMode === 'tshirt' && column === 'complexity') {
      return this.variables.tshirtSize;
    }

    switch (column) {
      case 'epic':
      case 'task':
        return this.variables.description;
      case 'userStory':
        return this.variables.userStory;
      case 'subTask':
        return this.variables.subTask;
      case 'complexity':
        return this.variables.complexity;
      case 'complexityCount':
        return `${this.variables.numberOfItems} x ${this.variables.effort}(h)`;
      case 'profile':
        return `${this.variables.profile} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.variables.cost;
      default:
        return '';
    }
  }

  private getToolHeader(column: string): string {
    switch (column) {
      case 'task':
        return this.variables.task;
      case 'subTask':
        return this.variables.subTask;
      case 'toolName':
        return this.variables.tool;
      case 'productivity':
        return this.variables.earnPercentual1;
      case 'gains':
        return this.variables.gainHour;
      case 'profile':
        return `${this.variables.profile} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.variables.cost;
      default:
        return '';
    }
  }

  private getRiskHeader(column: string): string {
    switch (column) {
      case 'name':
        return this.variables.projectType;
      case 'risk':
        return `${this.variables.risk} (%)`;
      case 'effort':
        return `${this.variables.effort} (h)`;
      case 'profile':
        return `${this.variables.profile} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.variables.cost;
      default:
        return '';
    }
  }

  private getConfigParamCellValue(column: string, detail: any): string {
    switch (column) {
      case 'name':
        return detail.name;
      case 'complexity':
        return this.toFixedValue(detail.complexity);
      case 'profile':
        return `${detail.profileName}-${this.toFixedValue(detail.profile)} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.toFixedValue(detail.cost);
      default:
        return '';
    }
  }

  private getMacroCellValue(column: string, detail: any): string {
    switch (column) {
      case 'name':
        return detail.name;
      case 'metodology':
        return detail.type;
      case 'complexity':
        return this.toFixedValue(detail.effort);
      case 'effort':
        return this.toFixedValue(detail.complexity);
      case 'profile':
        return `${detail.profileName}-${this.toFixedValue(detail.profile)} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.toFixedValue(detail.cost);
      default:
        return '';
    }
  }

  private getTaskCellValue(column: string, detail: any): string {
    switch (column) {
      case 'epic':
        return detail.epic || detail.name || '';
      case 'userStory':
        return detail.userStory || '';
      case 'task':
        return detail.task || '';
      case 'subTask':
        return detail.subTask || '';
      case 'complexity':
        if (this.combinedData.projectMetodology === 'agile' && this.combinedData.estimateMode === 'tshirt') {
          return detail.tshirtScaleLevel || '';
        }
        return detail.complexityLevel === '1' ? this.variables.low1
          : detail.complexityLevel === '2' ? this.variables.medium1
          : detail.complexityLevel === '3' ? this.variables.high1
          : this.variables.notApplic;
      case 'complexityCount':
        return detail.complexityCount || '';
      case 'profile':
        return `${detail.profileName}-${this.toFixedValue(detail.profile)} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.toFixedValue(detail.cost);
      default:
        return '';
    }
  }

  private getToolCellValue(column: string, detail: any): string {
    switch (column) {
      case 'task':
        return detail.actionName;
      case 'subTask':
        return detail.activityName;
      case 'toolName':
        return detail.toolName;
      case 'productivity':
        return this.toFixedValue(detail.productivity);
      case 'gains':
        return this.toFixedValue(detail.gains);
      case 'profile':
        return this.toFixedValue(detail.profile);
      case 'cost':
        return this.toFixedValue(detail.cost);
      default:
        return '';
    }
  }

  private getRiskCellValue(column: string, detail: any): string {
    switch (column) {
      case 'name':
        return detail.name;
      case 'risk':
        return this.toFixedValue(detail.risk);
      case 'effort':
        return this.toFixedValue(detail.effort);
      case 'profile':
        return `${detail.profileName} ${this.toFixedValue(detail.profile)}`;
      case 'cost':
        return this.toFixedValue(detail.cost);
      default:
        return '';
    }
  }

  private toFixedValue(value: any): string {
    return typeof value === 'number' ? value.toFixed(2) : value ?? '';
  }

  getProfileInfoTooltip(profileId: string | null): string {
    if (!profileId) {
      return this.variables?.noProfile || this.variables?.notApplic || '-';
    }

    const snapshot = this.combinedData.resultEstimates?.profileSnapshots?.find((ps: any) => ps.profileId === profileId);
    if (snapshot) {
      return `${snapshot.profileCenter}`;
    }

    return '-';
  }

}
